import { render, staticRenderFns } from "./CaseListView.vue?vue&type=template&id=0f16c40f&scoped=true"
import script from "./CaseListView.vue?vue&type=script&lang=js"
export * from "./CaseListView.vue?vue&type=script&lang=js"
import style0 from "./CaseListView.vue?vue&type=style&index=0&id=0f16c40f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f16c40f",
  null
  
)

export default component.exports